import { signIn } from 'next-auth/react';
import { useState } from 'react';

export default function SignInButton({ callbackUrl, classname }: { callbackUrl?: string; classname?: string }) {
    const [isLoading, setIsLoading] = useState(false);

    const handleSignIn = async () => {
        setIsLoading(true);
        await signIn('google', {
            callbackUrl: callbackUrl || '/form-dashboard',
        });
        setIsLoading(false);
    };

    return (
        <button className={`btn btn-outline hover:bg-white ${classname}`} aria-label="Sign in with Google" onClick={() => handleSignIn()}>
            <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google logo" width={20} height={20} />
            {isLoading ? (
                <>
                    <span className="loading loading-spinner loading-sm"></span>
                    Signing in...
                </>
            ) : (
                'Sign in with Google'
            )}
        </button>
    );
}
